import Helper from '@ember/component/helper';

export default class ToNumberHelper extends Helper {
  compute([value]: [string | number | null | undefined]) {
    if (value === null || value === undefined) return 0;

    const num = Number(value);
    return isNaN(num) ? 0 : num;
  }
}
